<small ng-if="!!lastSync">última atualização em: {{lastSync | date:'dd/MM/yy HH:mm:ss'}} </small>